



























import Vue from 'vue'
import UserActions from '@/components/Users/UserActions.vue'
import { userHeaders } from '@/components/Businesses/headers'
import { apiGetBusinessUsers, apiHardDeleteUser, apiRestoreUser, apiSoftDeleteUser } from '@/api'
import { mutations, portalState } from '@/state'

type User = { name: string; id: string }

export default Vue.extend({
  name: 'UsersTable',
  components: { UserActions },
  props: {
    selectedBusiness: Object,
    marginTop: String,
    search: String
  },
  computed: {
    headers () {
      return userHeaders(this.t)
    },
    loggedInUser () { return portalState.user }
  },
  data () {
    return {
      users: [],
      loading: true,
      footerProps: { itemsPerPageOptions: [10, 25, 50] },
    }
  },
  methods: {
    async initialize () {
      this.users = []
      this.loading = true
      const { id } = this.selectedBusiness

      apiGetBusinessUsers(id).then((res) => {
        const formattedUsers = res.data.data.map((user: {first_name: string; last_name: string}) => {
          return { ...user, name: `${user.first_name} ${user.last_name}` }
        })
        this.users = formattedUsers
        this.loading = false
      }).catch(e => {
        mutations.setSnackbar('error', e.response.data.message)
      }).finally(() => this.gsapFadeIn())
    },
    checkIfTrashed (item: { trashed: boolean }) {
      if (!item.trashed) return 'fade-in'
      if (this.$vuetify.theme.dark) return 'trashed-item-dark fade-in'
      return 'trashed-item fade-in'
    },
    clickEvent (e: { event: string; user: User }) {
      switch (e.event) {
        case 'editUser':
          this.$emit('userToBeEdited', e.user)
          break
        case 'deleteUser':
          this.deleteUser(e.user)
          break
        case 'restoreUser':
          this.restoreUser(e.user)
          break
        case 'hardDeleteUser':
          this.hardDeleteUser(e.user)
          break
      }
    },
    async deleteUser (user: User) {
      const { isConfirmed } = await this.sweetAlert(this.t({ s: 'confirmText', component: 'messages' }, [user.name]))
      if (!isConfirmed) return
      try {
        mutations.setSnackbar()
        await apiSoftDeleteUser(user.id).then(() => {
          this.initialize()
        })
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar'}))
      } catch (e) {
        mutations.setSnackbar('error', e.response.data.message)
      }
    },
    async restoreUser (user: User) {
      const { isConfirmed } = await this.sweetAlert(this.t({ s: 'confirmTextRestore', component: 'messages' }, [user.name]))
      if (!isConfirmed) return
      try {
        mutations.setSnackbar()
        await apiRestoreUser(user.id).then(() => {
          this.initialize()
        })
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar'}))
      } catch (e) {
        mutations.setSnackbar('error', e.response.data.message)
      }
    },
    async hardDeleteUser (user: User) {
      const { isConfirmed } = await this.sweetAlert(this.t({ s: 'confirmTextHardDelete', component: 'messages' }, [user.name]))
      if (!isConfirmed) return
      mutations.setSnackbar()
      await apiHardDeleteUser(user.id)
        .then(() => {
          mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar'}))
          this.initialize()
        }).catch((e: any) => mutations.setSnackbar('error', e.response.data.message))
    }
  },
  mounted () {
    this.initialize()
  },
  watch: {
    selectedBusiness () {
      this.initialize()
    }
  }
})
